(() => {
  function init(root = document) {
    const form = root.querySelector('#RjDesignTableForm');
    if (!form || form.dataset.enhanced) return;
    const page = form.closest('.rb-design');
    const params = new URLSearchParams(window.location.search);
    const model = (params.get('model') || '').slice(0, 160);
    const variant = (params.get('variant') || '').slice(0, 100);
    const origin = model ? model + (variant && variant !== 'Default Title' ? ' · ' + variant : '') : '';
    const originField = form.querySelector('[data-bespoke-origin]');
    const originLabel = form.querySelector('[data-bespoke-origin-label]');
    if (origin && originField && originLabel) {
      originField.value = origin;
      originLabel.textContent = 'Dit udgangspunkt: ' + origin + '. Du kan tilpasse ønskerne nedenfor.';
      originLabel.hidden = false;
    }
    const stages = [...form.querySelectorAll('[data-stage]')];
    const nav = page.querySelector('.rb-progress');
    const navButtons = [...nav.querySelectorAll('[data-go-stage]')];
    const controls = form.querySelector('.rb-step-controls');
    const back = controls.querySelector('[data-design-back]');
    const next = controls.querySelector('[data-design-next]');
    const submitArea = form.querySelector('.rj-table-design__submit');
    const summary = page.querySelector('.rb-summary');
    let stage = 0;
    const detailReset = form.querySelector('[data-clear-details]');
    const value = key => form.elements['contact[' + key + ']']?.value || '';
    const round = () => value('form') === 'Rundt';
    function toggle(selector, active) {
      const area = form.querySelector(selector);
      area.hidden = !active;
      area.querySelectorAll('input,textarea').forEach(field => { field.disabled = !active; });
    }
    function sync() {
      toggle('[data-rect-dimensions]', !round());
      toggle('[data-round-dimensions]', round());
      toggle('[data-other-wood]', value('træsort') === 'Anden træsort');
      toggle('[data-other-legs]', value('ben') === 'Anden type ben');
      const length = value('længde_cm'), width = value('bredde_cm'), diameter = value('diameter_cm');
      const dimensions = round() ? (diameter ? 'Ø ' + diameter + ' cm' : 'Diameter afklares') : (length || width ? (length || '?') + ' × ' + (width || '?') + ' cm' : 'Afklares sammen');
      const values = {
        form: round() ? 'Rundt' : 'Rektangulært', dimensions,
        træsort: value('træsort') === 'Anden træsort' && value('ønsket_anden_træsort') ? value('ønsket_anden_træsort') : value('træsort') || 'Afklares sammen',
        udtryk: value('udtryk') || 'Afklares sammen',
        ben: value('ben') === 'Anden type ben' && value('ønsket_anden_type_ben') ? value('ønsket_anden_type_ben') : value('ben') || 'Afklares sammen',
        tillægsplader: value('tillægsplader') || 'Afklares sammen'
      };
      Object.entries(values).forEach(([key, text]) => { summary.querySelector('[data-summary-key="' + key + '"]').textContent = text; });
      const labels = {form:'Form',dimensions:'Mål',træsort:'Træsort',udtryk:'Udtryk',ben:'Ben',tillægsplader:'Udtræk'};
      const summaryText = (origin ? 'Udgangspunkt: ' + origin + ' · ' : '') + Object.entries(values).map(([key,text])=>labels[key]+': '+text).join(' · ');
      detailReset.hidden = !stages[1].querySelector('input[type="radio"]:checked');
      form.querySelector('[data-design-summary-field]').value = summaryText;
      form.querySelector('[data-final-summary]').textContent = summaryText + (value('body').trim() ? '\nDine ønsker: ' + value('body').trim() : '');
      const rect = summary.querySelector('[data-plan-rect]'), circle = summary.querySelector('[data-plan-round]'), seam = summary.querySelector('[data-plan-seam]');
      rect.toggleAttribute('hidden', round()); seam.toggleAttribute('hidden', round()); circle.toggleAttribute('hidden', !round());
      const ratio = Math.min(5, Math.max(.45, (Number(length) || 240) / (Number(width) || 100)));
      const w = Math.min(260, 160 * ratio), h = w / ratio;
      rect.setAttribute('x', (320-w)/2); rect.setAttribute('y', (220-h)/2); rect.setAttribute('width', w); rect.setAttribute('height', h);
      seam.setAttribute('d', 'M' + ((320-w)/2) + ' 110H' + ((320+w)/2));
      const color = value('træsort') === 'Massiv valnød' ? '#79604b' : value('træsort') === 'Anden træsort' ? '#c8bfb0' : '#b2936b';
      rect.setAttribute('fill',color); circle.setAttribute('fill',color);
    }
    function validCurrentStage() {
      return [...stages[stage].querySelectorAll('input,textarea,select')].every(field => field.disabled || field.reportValidity());
    }
    function showStage(index, focus = true) {
      stage = index;
      stages.forEach((node, i) => { node.hidden = i !== stage; });
      navButtons.forEach((button, i) => { if (i === stage) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current'); });
      back.disabled = stage === 0;
      next.hidden = stage === stages.length - 1;
      next.textContent = stage === 0 ? 'Videre til materialer →︎' : 'Videre til forespørgsel →︎';
      submitArea.hidden = stage !== stages.length - 1;
      if (focus) stages[stage].querySelector('h3').focus();
    }
    navButtons.forEach(button => button.addEventListener('click', () => {
      const target = Number(button.dataset.goStage);
      if (target < stage || validCurrentStage()) showStage(target);
    }));
    back.addEventListener('click', () => showStage(Math.max(0, stage-1)));
    next.addEventListener('click', () => { if (validCurrentStage()) showStage(Math.min(stages.length-1, stage+1)); });
    detailReset.addEventListener('click',()=>{
      stages[1].querySelectorAll('input[type="radio"]').forEach(field=>{field.checked=false;});
      sync();stages[1].querySelector('h3').focus();
    });
    form.addEventListener('input', sync);
    form.addEventListener('change', sync);
    form.addEventListener('invalid', event => {
      const targetStage = event.target.closest('[data-stage]');
      if (targetStage && Number(targetStage.dataset.stage) !== stage) showStage(Number(targetStage.dataset.stage), false);
    }, true);
    form.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.matches('input') && stage < stages.length-1) {
        event.preventDefault();
        if (validCurrentStage()) showStage(stage+1);
      }
    });
    form.addEventListener('submit', sync);
    form.dataset.enhanced = 'true';
    nav.hidden = false; controls.hidden = false; summary.hidden = false;
    sync();
    const success = form.querySelector('.rj-table-design__success');
    if (success) {
      [...stages, nav, controls, summary, submitArea].forEach(node => { node.hidden = true; });
      success.focus();
      return;
    }
    const hasFeedback = form.querySelector('.errors');
    showStage(hasFeedback ? stages.length-1 : 0, false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
